import { createSlice } from "@reduxjs/toolkit";
import Persistor from "../store/Persistor";
const authFromLocalStorage = JSON.parse(Persistor.get('auth') || '{"user":null,"token":{"access_token":null,"refresh_token":null}}');
const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: authFromLocalStorage.user,
    token: {
      access_token: authFromLocalStorage.token.access_token,
      refresh_token: authFromLocalStorage.token.refresh_token
    }
  },
  reducers: {
    setLoggedIn: (state, action) => {
      const { user, token } = action.payload;
      Persistor.store(
        'auth',
        JSON.stringify({
          user: user,
          token: token
        })
      );
      state.user = user;
      state.token = {
        access_token: token.access_token,
        refresh_token: token.refresh_token
      }
    },
    setLoggedOut: (state, action) => {
      Persistor.remove('auth');
      state.user = null;
      state.token = {
        access_token: null,
        refresh_token: null
      };
    },
    unsetAccessToken: (state, action) => {
      state.token = action.payload.token
    }
  },
})

export const { setLoggedIn, setLoggedOut, unsetAccessToken } = authSlice.actions;

export default authSlice.reducer;

export const selectAuth = (state) => state.auth;
export const selectCurrentUser = (state) => state.auth.user;
export const selectCurrentToken = (state) => state.auth.token;

export const loggedIn = (user, token) => {
  return {
    user: user,
    token: {
      access_token: token?.access_token,
      refresh_token: token?.refresh_token
    }
  }
}

export const loggedOut = () => {
  return {
    user: null,
    token: {
      access_token: null,
      refresh_token: null
    }
  }
}
